import genericHelpers from 'Utils/generic-helpers';

const finishValue = (finish, finishKeys) => {
  const finishKey = finish.key;
  return finishKeys.indexOf(finishKey) === -1
    ? `${finishKeys[0]}`
    : `${finishKey}`;
};

const availableFinishOptions = (finishes, finishKeys) => {
  return (finishes || []).map(finish => ({
    value: `${finish.key}`,
    label: genericHelpers.capitalizeString(finish.title),
    disabled: finishKeys.indexOf(finish.key) === -1,
  }));
};

const calculateSelectedFinish = (
  deliveryOptionKey,
  value,
  finishesByDeliveryOption
) =>
  (finishesByDeliveryOption[deliveryOptionKey] || []).reduce((memo, finish) =>
    value === finish.key.toString() ? finish : memo
  );

const availableFinishKeys = (finishesByDeliveryOption, deliveryOption) =>
  (finishesByDeliveryOption[deliveryOption.key] || []).map(
    delivery => delivery.key
  );

const availableDeliveryOptions = (deliveryOptions, finishesByDeliveryOption, useMobileTitle = false) =>
  deliveryOptions.map(deliveryOption => ({
    value: `${deliveryOption.key}`,
    label: genericHelpers.capitalizeString(
      useMobileTitle ? deliveryOption.mobile_title : deliveryOption.title
    ),
    disabled: !finishesByDeliveryOption[deliveryOption.key],
  }));

const availableDeliveryOptionsForFinish = (
  deliveryOptions,
  finishesByDeliveryOption,
  selectedFinish,
  useMobileTitle
) =>
  deliveryOptions.map(deliveryOption => ({
    value: `${deliveryOption.key}`,
    label: useMobileTitle ? deliveryOption.mobile_title : deliveryOption.title,
    code: deliveryOption.code,
    disabled: !(finishesByDeliveryOption[deliveryOption.key] || []).find(
      f => f.key === selectedFinish.key
    ),
  }));

const selectedDeliveryOption = (deliveryOptions, value) =>
  deliveryOptions.reduce((memo, deliveryOption) =>
    value === deliveryOption.key.toString() ? deliveryOption : memo
  );

const addSelectedAttributeToOptions = (options, selectedValue) =>
  options.map(option => ({
    ...option,
    selected: `${option?.value || option?.key}` === `${selectedValue}`,
  }));

export {
  availableFinishKeys,
  finishValue,
  availableFinishOptions,
  calculateSelectedFinish,
  availableDeliveryOptions,
  availableDeliveryOptionsForFinish,
  selectedDeliveryOption,
  addSelectedAttributeToOptions,
};
